import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=64d8e7de&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8e7de",
  null
  
)

component.options.__file = "Footer.vue"
export default component.exports